import { merge } from 'lodash-es'
import getConfig, { type CoreUrlsConfig } from '@/config/config'
import configDev from '@/config/configDev'
import type { Config } from '@/core/types'
import { isDev, isStaging } from '@/utils/system'
import { configStaging } from '@/config/configStaging'

class ConfigReader {
  public static config(envSource = import.meta.env): Config {
    const baseConfig = merge(getConfig(envSource), isStaging ? configStaging : {})

    if (isDev) {
      return merge(baseConfig, configDev) as Config
    }

    if (envSource.VUE_APP_ALLOW_REWRITE_CONFIG === 'true' && window.__appConfiguration) {
      const coreUrlsConfig: CoreUrlsConfig = {
        appUrl: window.__appConfiguration.appUrl,
        apiUrl: window.__appConfiguration.apiUrl,
        socketUrl: window.__appConfiguration.socketUrl,
      }

      return merge(baseConfig, coreUrlsConfig) as Config
    }

    return merge(baseConfig, window.__appConfiguration) as Config
  }
}

export default ConfigReader
